const FIELD_KIND = {
  initials: 'initials',
  acknowledgement: 'acknowledgement',
  signature: 'signature'
};
const MAX_INITIALS_LENGTH = 8;
const KNOWN_KINDS = Object.values(FIELD_KIND);
const normalizeAddendumFields = fields =>
  Array.isArray(fields)
    ? fields.filter(
        field =>
          field &&
          typeof field.id === 'string' &&
          KNOWN_KINDS.includes(field.kind)
      )
    : [];
const trimmedInitials = value =>
  typeof value === 'string' ? value.trim() : '';
const isAddendumFieldComplete = (field, values, signature) => {
  const value = (values || {})[field.id];
  if (field.kind === FIELD_KIND.initials) {
    const initials = trimmedInitials(value);
    return initials.length > 0 && initials.length <= MAX_INITIALS_LENGTH;
  }
  if (field.kind === FIELD_KIND.acknowledgement) return value === true;
  return Boolean(signature);
};
const addendumFieldsComplete = (fields, values, signature) =>
  normalizeAddendumFields(fields).every(field =>
    isAddendumFieldComplete(field, values, signature)
  );
const addendumRequiresSignature = fields =>
  normalizeAddendumFields(fields).some(
    field => field.kind === FIELD_KIND.signature
  );
const addendumFieldValues = (fields, values) =>
  normalizeAddendumFields(fields).reduce((payload, field) => {
    const value = (values || {})[field.id];
    if (field.kind === FIELD_KIND.initials && trimmedInitials(value)) {
      return { ...payload, [field.id]: trimmedInitials(value) };
    }
    if (field.kind === FIELD_KIND.acknowledgement && value === true) {
      return { ...payload, [field.id]: true };
    }
    return payload;
  }, {});
const escapeHtml = text =>
  String(text)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
const stampAddendumPreview = (html, values) =>
  (html || '').replace(
    /<span data-initials-field="([^"]+)">[^<]*<\/span>/g,
    (slot, fieldId) => {
      const initials = trimmedInitials((values || {})[fieldId]);
      return initials
        ? `<span data-initials-field="${fieldId}" class="addendum-stamp">${escapeHtml(
            initials
          )}</span>`
        : slot;
    }
  );
module.exports = {
  FIELD_KIND,
  MAX_INITIALS_LENGTH,
  addendumFieldValues,
  addendumFieldsComplete,
  addendumRequiresSignature,
  isAddendumFieldComplete,
  normalizeAddendumFields,
  stampAddendumPreview
};
